import { render } from "./Manage.vue?vue&type=template&id=3a77f62f&ts=true"
import script from "./Manage.vue?vue&type=script&lang=ts"
export * from "./Manage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__